import { getPath } from "lib/lodash";

export const catalogueSizesApiIdsSelector = state => {
  const cataloguePagesForScope = getPath(state, `api.catalogueSizes.pages`, {});
  return Object.values(cataloguePagesForScope).reduce(
    (ids, page) => [...ids, ...getPath(page, "ids", [])],
    []
  );
};
